import { CONFIG } from './config';
import { COLUMNS } from './columns';
import { CUSTOM_COLUMN } from './customColumn';

export default {
  CONFIG,
  COLUMNS,
  CUSTOM_COLUMN,
};
